import * as types from "./ProviderCapacityInputActionType";

// Fetch Capacity Input
export const fetchCapacitiesRequest = (params = {}) => ({
  type: types.FETCH_CAPACITY_INPUT_NEW_REQUEST,
  payload: params,
});
export const fetchCapacityInputSuccess = (data) => ({
  type: types.FETCH_CAPACITY_INPUT_NEW_SUCCESS,
  payload: data,
});
export const fetchCapacityInputFailure = (error) => ({
  type: types.FETCH_CAPACITY_INPUT_NEW_FAILURE,
  payload: error,
});

// Fetch Capacity Filter Masters
export const fetchCapacityFiltersRequest = () => ({
  type: types.FETCH_CAPACITY_FILTERS_NEW_REQUEST,
});
export const fetchCapacityFiltersSuccess = (data) => ({
  type: types.FETCH_CAPACITY_FILTERS_NEW_SUCCESS,
  payload: data,
});
export const fetchCapacityFiltersFailure = (error) => ({
  type: types.FETCH_CAPACITY_FILTERS_NEW_FAILURE,
  payload: error,
});

// Fetch Default RAD Capacity
export const fetchDefaultRadCapacityRequest = () => ({
  type: types.FETCH_DEFAULT_RAD_CAPACITY_NEW_REQUEST,
});
export const fetchDefaultRadCapacitySuccess = (data) => ({
  type: types.FETCH_DEFAULT_RAD_CAPACITY_NEW_SUCCESS,
  payload: data,
});
export const fetchDefaultRadCapacityFailure = (error) => ({
  type: types.FETCH_DEFAULT_RAD_CAPACITY_NEW_FAILURE,
  payload: error,
});

// Update RAD Capacity Input
export const updateRadCapacityInputRequest = (updateData) => ({
  type: types.UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST,
  payload: updateData,
});
export const updateRadCapacityInputSuccess = (data) => ({
  type: types.UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS,
  payload: data,
});
export const updateRadCapacityInputFailure = (error) => ({
  type: types.UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE,
  payload: error,
});

// Bulk Update RAD Capacity Input
export const bulkUpdateRadCapacityInputRequest = (bulkData, filters = {}) => ({
  type: types.BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST,
  payload: bulkData,
  filters,
});
export const bulkUpdateRadCapacityInputSuccess = (data) => ({
  type: types.BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS,
  payload: data,
});
export const bulkUpdateRadCapacityInputFailure = (error) => ({
  type: types.BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE,
  payload: error,
});

// RAD Capacity IP Upload
export const radCapacityIpUploadRequest = (fileData) => ({
  type: types.RAD_CAPACITY_IP_UPLOAD_NEW_REQUEST,
  payload: fileData,
});
export const radCapacityIpUploadSuccess = (data) => ({
  type: types.RAD_CAPACITY_IP_UPLOAD_NEW_SUCCESS,
  payload: data,
});
export const radCapacityIpUploadFailure = (error) => ({
  type: types.RAD_CAPACITY_IP_UPLOAD_NEW_FAILURE,
  payload: error,
});
